/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaDoubleBurnerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxSedonaDoubleBurner').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'BURNER_LYNX_LSB502',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-sedona-double-burner.js.map